import { createSelector } from 'reselect';
import getOptinState from './getOptinState';
import { OptinAttributesState, OptinState } from '../types';
import { RootState } from '../../../stores/types';

export default createSelector<RootState, OptinState, OptinAttributesState>(
  getOptinState,
  (optinState: OptinState) => optinState.entities.attributes,
);
